import React, { useState, useEffect } from 'react';

const BusinessListModal = ({ show, onClose, gaonSrNo, onAdd }) => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    bname: '',
    category: '',
    mobile: '',
    address: ''
  });
  const [businesses, setBusinesses] = useState([]);
  const [categories, setCategories] = useState([]);

  const normalizeCategory = (str) => str.trim().toLowerCase();

  useEffect(() => {
    if (gaonSrNo) {
      fetch(`https://mazagaon.co.in/api/get_business_list.php?gaonSrNo=${gaonSrNo}`)
        .then((res) => res.json())
        .then((data) => {
          setBusinesses(data);
          const normalized = [...new Set(data.map((b) => normalizeCategory(b.category)))];
          setCategories(normalized);
        });
    }
  }, [gaonSrNo]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const payload = { ...formData, gaonSrNo };

    fetch('https://mazagaon.co.in/api/submit_business_list.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          alert('✅ व्यवसाय सेव्ह झाला!');
          fetch(`https://mazagaon.co.in/api/get_business_list.php?gaonSrNo=${gaonSrNo}`)
            .then((res) => res.json())
            .then((data) => {
              setBusinesses(data);
              const normalized = [...new Set(data.map((b) => normalizeCategory(b.category)))];
              setCategories(normalized);
            })
            .catch((err) => {
              console.error('Re-fetch error:', err);
            });
          setFormData({ bname: '', category: '', mobile: '', address: '' });
          setShowForm(false);
        } else {
          alert('❌ Error: ' + result.message);
        }
      })
      .catch((err) => {
        console.error('Submission error:', err);
        alert('❌ Server error while saving business');
      });
  };

  const formatCategory = (cat) => cat.charAt(0).toUpperCase() + cat.slice(1);

  return (
    <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">आपल्या गावातील व्यवसाय</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            {/* 🌟 Featured Businesses */}
            <h6 className="mb-3">🌟 Featured Businesses</h6>
            <div className="d-flex flex-wrap gap-3 mb-4">
              {businesses.map((biz, idx) => (
                <div key={idx} className="card p-2">
                  <h6>{biz.bname}</h6>
                  <p className="mb-1">{biz.address}</p>
                  <small>{biz.mobile}</small>
                </div>
              ))}
            </div>

            {/* 💼 Business Directory */}
            <h6>💼 Business Directory</h6>
            <div className="accordion mb-4" id="businessAccordion">
              {categories.map((cat, i) => (
                <div className="accordion-item" key={i}>
                  <h2 className="accordion-header" id={`heading${i}`}>
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${i}`}
                    >
                      {formatCategory(cat)}
                    </button>
                  </h2>
                  <div
                    id={`collapse${i}`}
                    className="accordion-collapse collapse"
                    data-bs-parent="#businessAccordion"
                  >
                    <div className="accordion-body">
                      {businesses.filter(b => normalizeCategory(b.category) === cat).length === 0 ? (
                        <p className="text-muted">📭 No businesses in this category</p>
                      ) : (
                        <ul className="mb-0">
                          {businesses
                            .filter(b => normalizeCategory(b.category) === cat)
                            .map((b, j) => (
                              <li key={j}>{b.bname} - {b.mobile}</li>
                            ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Add Business Button */}
            {!showForm && (
              <div className="bottom-adbiz text-center">
                <button className="btn btn-primary mt-2" onClick={() => setShowForm(true)}>+ नवीन व्यवसाय जोडा</button>
              </div>
            )}

            {/* Add Business Form */}
            {showForm && (
              <div className='bottom-adbiz p-4'>
                <h4>नवीन व्यवसाय जोडण्यासाठी फॉर्म</h4>
                <form className="m-4">
                  <div className="mb-3">
                    <label className="form-label">व्यवसायाचे नाव</label>
                    <input type="text" className="form-control" name="bname" value={formData.bname} onChange={handleChange} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">व्यवसाय प्रकार</label>
                    <input type="text" className="form-control" name="category" value={formData.category} onChange={handleChange} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">मोबाईल नंबर</label>
                    <input type="text" className="form-control" name="mobile" value={formData.mobile} onChange={handleChange} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">पत्ता</label>
                    <input type="text" className="form-control" name="address" value={formData.address} onChange={handleChange} />
                  </div>
                  <div className="d-flex justify-content-between">
                    <button type="button" className="btn btn-success" onClick={handleSubmit}>सबमिट करा</button>
                    <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>रद्द करा</button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessListModal;
